<template>
    <v-container :style="fullWidth ? 'margin: 0px !important; padding: 0px;' : ''" v-if="(editingIndex == null || !editable) && images.length">
        <v-carousel
            :cycle="cycle"
            :height="maxHeight ? maxHeight : 'auto'"
            style="text-align: center;"
            hide-delimiters
            show-arrows-on-hover
            :interval="10000"
        >
            <v-carousel-item
                @mouseenter="setCycle(false)"
                @mouseleave="setCycle(true)"
                @click="selectImage(i)"
                :class="image.link && image.likType == 'IMG' || editable ? 'placeholder-container' : ''"
                v-for="(image, i) in images"
                :key="i"
            >
                <img v-if="image" @click="image.linkType == 'IMG' && !editable ? goToLink(image.link) : undefined" :height="maxHeight" :width="fullWidth ? '100%' : width || maxHeight + 75" align-center :src="image.src" />'
                <v-btn v-if="image.linkType == 'BTN' && image.linkLabel">{{ image.linkLabel }}</v-btn>
            </v-carousel-item>
        </v-carousel>
        <span v-if="images.length && !fullWidth">{{ images.length }} Image{{ images.length > 1 ? 's' : '' }}</span>
    </v-container>
    <v-container v-else-if="editingIndex != null">
        <img
            @click="selectImage(null)"
            style="cursor: pointer;"
            align-center
            :height="maxHeight ? maxHeight : 'auto'"
            :src="focusedImage ? focusedImage.src : ''"
        />
        <v-row>
            <v-col cols="5">
                <v-btn-toggle @change="changeLinkType(editingIndex, $event)" :value="focusedImage.linkType" mandatory>
                    <v-btn value="TXT">TEXT</v-btn>
                    <v-btn value="IMG">IMAGE</v-btn>
                    <v-btn value="BTN">BTN</v-btn>
                </v-btn-toggle>
            </v-col>
            <v-col cols="2"></v-col>
            <v-col cols="5">
                <v-text-field v-model="focusedImage.link" @input="changeLink(editingIndex, $event)" label="Click Link" outlined></v-text-field>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="5">
                <site-button
                    btnType="text"
                    :colNum="11"
                    @click-event="removeImage(editingIndex)"
                    toolTip="Remove Image"
                    toolTipClasses="delete-tooltip"
                    colorClasses="secondary-icon"
                    iconString="fas fa-trash"
                ></site-button>
            </v-col>
            <v-col cols="2"></v-col>
            <v-col cols="5">
                <site-button
                    btnType="text"
                    :colNum="11"
                    iconType="SVG"
                    @click-event="inputClick"
                    toolTip="Replace Image"
                    :iconString="imageSwap"
                ></site-button>
                <input
                    ref="replace-image"
                    style="display: none;"
                    type="file"
                    accept="image/*"
                    @change="replaceImage(editingIndex, $event)"
                />
            </v-col>
        </v-row>
    </v-container>
</template>

<style lang="scss" scoped>
@import '../../styles/styles.scss';
.placeholder-container {
    cursor: pointer;
}
</style>

<script>
import SiteButton from '../common/SiteButton'
import ImageSwap from '../../assets/Image-Swap.svg'
import { mask } from 'vue-the-mask'

export default {
    name: 'photo-carousel',
    components: {
        'site-button': SiteButton,
    },
    directives: {
        mask: mask,
    },
    data: () => ({
        cycle: true
    }),
    props: {
        images: {
            type: Array,
            default: () => [],
        },
        editable: {
            type: Boolean,
            default: undefined,
        },
        editingIndex: {
            type: Number,
            default: undefined,
        },
        maxHeight: {
            type: Number,
            default: undefined,
        },
        width: {
            type: Number,
            default: undefined
        },
        fullWidth: {
            type: Boolean,
            default: undefined
        }
    },
    methods: {
        changeLink(i, event) {
            this.$emit('change-link',this.images[i]._id, i, event)
        },
        changeLinkType(i, event) {
            this.$emit('change-link-type',this.images[i]._id, i, event)
        },
        removeImage(i) {
            this.$emit('remove-image', this.images[i]._id, i)
        },
        goToLink(link) {
            console.log('link ' + link);
            window.open(link, '_blank');
        },
        inputClick() {
            console.log('replace-image')
            this.$refs['replace-image'].click()
        },
        replaceImage(editIndex, $event) {
            console.log('replace ' + editIndex)
            this.$emit('replace-image', this.images[editIndex]._id, $event, editIndex)
        },
        selectImage(i) {
            console.log('select-image ' + i)
            this.$emit('select-image', i)
        },
        setCycle(state) {
            this.cycle = state;
        }
    },
    computed: {
        focusedImage() {
            return this.images[this.editingIndex]
        },
        imageSwap() {
            return ImageSwap
        },
    },
}
</script>

<style>
@import '/styles/site-styles.scss';
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
    margin: 40px 0 0;
}
ul {
    list-style-type: none;
    padding: 0;
}
li {
    display: inline-block;
    margin: 0 10px;
}
a {
    color: #42b983;
}
</style>
